import React from 'react';

import Header from '../../components/HeaderNoMenu';
import Button from '../../components/Button'
import { Container, H1, Line, Information, P, Span } from './styles';

export default function RechargeSummary() {
    return (
        <>
            <Header />
            <Container>
                <H1>Resumo de recarga</H1>
                <Line></Line>
                <Information>
                    <p className="vivo">Vivo</p>
                    <P>Recarga de TV</P>
                    <p className="pago">Pré-Pago Vivo R$50,00 <Span> 1.223<span className="pts">Pts</span></Span></p>
                    <P>Código do Cliente <Span>0303003033</Span></P>
                </Information>
                <Line></Line>
                <P>Total <Span>1.233<span className="pts">Pts</span></Span></P>
                <Button className="button">CONTINUAR</Button>
            </Container>
        </>
    );
}